export default "__VITE_ASSET__0f45fcc6__"